<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row>
      <v-col cols="12" md="2">
        <v-autocomplete
          v-model="paramberita.type"
          :items="listtype"
          label="Type"
          name="tipeberita">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="paramberita.category"
          :items="listcategory"
          label="Category"
          name="kategoriberita">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="5">
        <v-text-field
          prepend-inner-icon="search"
          v-model="paramberita.keyword"
          label="Information title, keyword"
          name="keyword">
        </v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn
          class="mt-1 white--text"
          type="submit"
          large
          :color="maincolor"
          block
          @click="getBeritaFilter">
          <v-icon left>search</v-icon> Search
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="datalist.length > 0">
      <v-col
        class="d-flex"
        cols="12"
        md="4"
        v-for="(news, i) in datalist"
        :key="i">
        <v-card
          class="d-flex flex-column w100">
          <v-img
            class="white--text align-end flex-grow-0 flex-shrink-1"
            height="225px"
            :lazy-src="require('../assets/default.jpg')"
            :src="api + '/upload/news/' + news.pic_berita">
          </v-img>
          <v-card-subtitle>
            <h1 class="title font-weight-bold mb-3">
              <router-link class="text-decoration-none text-ellipsis--2"
                :title="news.judul_berita"
                :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                {{ news.judul_berita }}
              </router-link>
            </h1>
            <div class="d-flex">
              <v-chip
                class="mr-1"
                color="deep-orange"
                small
                dark
                :title="news.tgl_berita">
                <v-icon left small>
                  mdi-update
                </v-icon>
                <timeago :datetime="news.tgl_berita"></timeago>
              </v-chip>
              <v-chip
                class="mr-1"
                color="success"
                small
                dark>
                <v-icon left small>
                  mdi-alpha-t-circle
                </v-icon>
                {{ news.type_berita }}
              </v-chip>
              <v-chip
                class="mr-1"
                color="primary"
                small
                dark>
                <v-icon left small>
                  mdi-alpha-c-circle
                </v-icon>
                {{ news.cat_berita }}
              </v-chip>
            </div>
          </v-card-subtitle>
          <v-card-text class="text--primary flex-grow-1 flex-shrink-0">
            <div class="text-ellipsis--3" v-html="news.prev_berita"></div>
          </v-card-text>
          <v-card-actions v-if="false">
            <v-btn
              class="mx-2"
              fab
              depressed
              dark
              x-small
              :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
              <v-icon dark>
                mdi-arrow-right
              </v-icon>
            </v-btn>
            <span>{{ $t('button.readmore') }}</span>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="datalist.length <= 0">
      <v-col cols="12" md="12">
        <p>Data not available!</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <infinite-loading :identifier="infiniteId" @infinite="getBerita">
          <div slot="spinner">Loading...</div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';

export default {
  name: 'News',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    baseurl: process.env.VUE_APP_BASEURL,
    publickey: '123',
    datalist: [],
    listtype: ['berita', 'agenda', 'pengumuman', 'file'],
    listcategory: [
      'jurusan',
      'pnb',
      'pendidikan',
      'penelitian',
      'pengabdian',
      'kerjasama',
      'mahasiswa',
      'bali',
      'covid',
      'pendaftaran',
      'pkkmb',
      'zi-wbk',
    ],
    panduan: null,
    paramberita: {
      type: '',
      category: '',
      lang: '',
      keyword: '',
      limit: 9,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
  }),
  mounted() {
    // this.getBerita();
    if (this.$route.query.type && this.$route.query.type !== '') {
      this.paramberita.type = this.$route.query.type;
      this.getBeritaFilter();
    }
    if (this.$route.query.category && this.$route.query.category !== '') {
      this.paramberita.category = this.$route.query.category;
    }
  },
  watch: {
    '$route.query.type'(val) {
      if (val) {
        this.paramberita.type = val;
        this.getBeritaFilter();
      }
    },
    '$route.query.category'(val) {
      if (val) {
        this.paramberita.category = val;
      }
    },
    '$i18n.locale'(val) {
      if (val) {
        // console.log(val);
        this.getBeritaFilter();
      }
    },
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    getBeritaFilter() {
      this.paramberita.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getBerita($state) {
      this.paramberita.lang = this.$i18n.locale;
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramberita.offset += this.paramberita.limit;
                this.datalist.push(...resdata.data);
                if (this.datalist.length < this.paramberita.offset) {
                  $state.complete();
                } else {
                  $state.loaded();
                }
              } else {
                $state.complete();
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
